/**
 * Single source of truth for the public share domain (pollendots.com).
 *
 * All customer-facing share URLs — investor brief, itinerary, vendor crew,
 * journey, network, celebrations, customer profile — go through this domain
 * because pollendots.com's Nginx proxies `/connection/*`, `/api/*` and `/og/*`
 * to the Emergent app, so the URL bar always reads pollendots.com.
 *
 * Override at build time via `REACT_APP_PUBLIC_SHARE_DOMAIN`. If unset, we
 * default to https://pollendots.com (and never fall back to the deployment
 * host — that would leak `intelligence.thecaravannetwork.com` into shared
 * links, which is the bug this constant was created to prevent).
 */
export const SHARE_DOMAIN =
  process.env.REACT_APP_PUBLIC_SHARE_DOMAIN || 'https://pollendots.com';
